import pcbanglogo from './pcbanglogo.png'
import { lorem, dynamicResourceLinks } from './util'

const Home = () => {
	var link = {
		fb: "https://web.facebook.com/PCBANG.MA",
		geo: `https://www.google.com/search?q=31°39'57.2"N+8°00'38.6"W`,
		ig: "https://www.instagram.com/pcbang_g/",
		gps: "Bd Allal Al Fassi, Marrakech 40000"
	}
	var mapslink = "https://www.google.com/maps/place/PC+Bang/@31.6659069,-8.0107334,19z/data=!4m5!3m4!1s0xdafedb256dd0a33:0x96ca8f763f1b5143!8m2!3d31.6659343!4d-8.0107946"
	// var goto = useGoto("/test")
	var goto = () => {}
	return (
		<div className="home pagebody">
			<div className="mainbody">
				<div className="section hero">
					<div className="images">
						<img src={pcbanglogo} alt="" className="cheats" />
						<img src={pcbanglogo} alt="" className="logo left" />
						<img src={pcbanglogo} alt="" className="logo right" />
					</div>
					<div className="body">
						<div className="container">
							<div className="items top">
								<div className="wtpw">
									<h1 className="welcome">WELCOME</h1>
									<h1 className="to">TO</h1>
									<div className="pcbangwebsite">
										<h1 className="pcbang">PC&nbsp;BANG</h1>
										<h2 className="website">web&nbsp;site</h2>
									</div>
								</div>
								<div className="desc">{lorem(19)}</div>
							</div>
							<div className="items middle">{lorem(30)}</div>
							<div className="items bottom">
								<div className="discovermore">DISCOVER MORE</div>
							</div>
						</div>
					</div>
				</div>
				<div className="navpad"></div>
				<div className="section aboutussection">
					<div className="aboutus">
						<div className="title">
							<h1 className="about">ABOUT</h1>
							<h1 className="us">US</h1>
						</div>
						<div className="aboutustext">{lorem(50)}</div>
						<div className="bottom">
							<div className="discovermore">DISCOVER MORE</div>
						</div>
					</div>
				</div>
				<div className="navpad" onClick={goto}></div>
				<div className="section contactinfo">
					<div className="top">
						<div className="fb co" onClick={() => { window.location = link.fb }}>
							<img src={dynamicResourceLinks("ff3366", 100).facebookIcon} alt="" className="img" />
							<div className="desc">{link.fb}</div>
						</div>
						<div className="geo co" onClick={() => { window.location = link.geo }}>
							<img src={dynamicResourceLinks("ff3366", 100).globeIcon} alt="" className="img" />
							<div className="desc">{link.geo}</div>
						</div>
						<div className="ig co" onClick={() => { window.location = link.ig }}>
							<img src={dynamicResourceLinks("ff3366", 100).instagramIcon} alt="" className="img" />
							<div className="desc">{link.ig}</div>
						</div>
					</div>
					<div className="gps co" onClick={() => { window.location = mapslink }}>
						<img src={dynamicResourceLinks("ff3366", 100).gpsPinIcon} alt="" className="img" />
						<div className="desc">{link.gps}</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Home;